module.exports = __webpack_public_path__ + "static/media/hackerrank_logo.eb82e7e6.png";